import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;

// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import authService from '../../services/auth'; // 로그인 상태를 확인하는 authService

// const ProtectedRoute = ({ children }) => {
//   const isLoggedIn = authService.isAuthenticated(); // 로그인 여부 확인

//   // 로그인되어 있지 않으면 로그인 페이지로 리디렉션
//   if (!isLoggedIn) {
//     return <Navigate to="/login" />;
//   }

//   // 로그인되어 있으면 자식 컴포넌트(즉, 대시보드 또는 테스트 페이지)를 렌더링
//   return children;
// };

// export default ProtectedRoute;
